import styled from 'styled-components';
import CheckboxEditOverlayChip from '../PDFOverlayChips/Checkbox/Edit';
import ImageEditOverlayChip from '../PDFOverlayChips/Image/Edit';
import SinatureEditOverlayChip from '../PDFOverlayChips/SignatureAndInitials/Edit';
import SignDateWithEmailAssignEditChip from '../PDFOverlayChips/SignDate/EditWithEmailAssign';
import TextAreaEditOverlayChip from '../PDFOverlayChips/TextArea/Edit';
import TextBoxEditOverlayChip from '../PDFOverlayChips/TextBox/Edit';
import SignDateEditOverlayChip from '../PDFOverlayChips/SignDate/Edit';

import { LineItemEditOverlayChip } from '../LineItems';
import DropdownEditOverlayChip from '../PDFOverlayChips/Dropdown/Edit';
import PrefilledFieldsEditOverlayChip from '../PDFOverlayChips/PrefilledFields/Edit';
import PrefilledFieldsImageEditOverlayChip from '../PDFOverlayChips/PrefilledFields/ImageEdit';
import FileUploadEdit from '../PDFOverlayChips/FileUploadV3/FileUploadEdit';

import APP_CONFIG from '../../config';
import LinkEditOverlayChip from '../PDFOverlayChips/Link/Edit';

const ChipContainer = styled.div`
  width: fit-content;
  position: absolute;
  z-index: 1;
  font-size: 11px;
  font-weight: 400;

  .signature {
    min-width: 180px;
    border: 4px solid rgba(0, 115, 234, 0.4);
    border-radius: 4px;
    background-color: #e6e9ef;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
    font-size: 14px;
    line-height: 22px;
    height: 33px;
    color: #0073ea;
    font-weight: 400;

    &.cursor-grabbing {
      cursor: grabbing;
    }
    svg {
      box-sizing: content-box;
      padding: 10px;
    }
  }

  .item-value-container {
    position: relative;

    div {
      /* border: 1px solid transparent; */
      &.active {
        border: 1px solid #3a87fd;
      }
      .resizeable {
        min-width: 3rem;
        height: fit-content;
        width: fit-content;
        cursor: move;
        &.active {
          border: 1px solid #3a87fd;
        }
      }

      .resizeable#checkbox,
      .resizeable#sign-date {
        min-width: auto;
        height: fit-content;
        width: fit-content;
        cursor: move;

        &.active {
          border: 1px dashed #3a87fd;
          border-radius: 5px;
        }
      }

      &.cursor-grab {
        cursor: grab;
      }

      &.cursor-grabbing {
        cursor: grabbing;
      }
    }
  }

  .no-wrap {
    white-space: nowrap;
  }
`;

const CustomButtonWrapper = styled.div`
  padding: 5px 8px;
  width: max-content;
  color: white;
  border-radius: 4px;
  background-color: ${({ buttonColor }) => buttonColor || '#0073ea'};
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
`;

const SIGNATURE_FIELDS = [
  'receiver-initials',
  'sender-initials',
  'receiver-signature',
  'sender-signature',
  APP_CONFIG.form_fields.signatureField.id,
  APP_CONFIG.form_fields.initialsField.id,
];

const CustomDragLayerBody = ({ item, itemData, xCoordinate, yCoordinate }) => {
  const itemValueContainerClasses = `cursor-grabbing ${
    itemData.isActive &&
    !['checkbox', 'sign-date', 'text-box', 'line-item'].includes(
      itemData.itemId,
    )
      ? 'active'
      : ''
  }`;

  return (
    <>
      <ChipContainer
        x={xCoordinate}
        y={yCoordinate}
        fontSize={itemData?.fontSize || 11}
      >
        <div className="item-value-container">
          <div
            style={{
              fontSize: (itemData?.fontStyle?.fontSize || 11) + 'px',
              lineHeight: itemData.itemId === 'checkbox' ? '' : 0.75,
              textAlign: itemData?.fontStyle?.alignment || 'left',
              fontWeight: itemData?.fontStyle?.bold ? 800 : 400,
              fontStyle: itemData?.fontStyle?.italics ? 'italic' : 'normal',
              color:
                `rgb(${itemData?.fontStyle?.color.r}, ${itemData?.fontStyle?.color.g}, ${itemData?.fontStyle?.color.b})` ||
                'rgb(0,0,0)',
            }}
            className={itemValueContainerClasses}
          >
            {SIGNATURE_FIELDS.includes(itemData.itemId) ? (
              <SinatureEditOverlayChip item={itemData} />
            ) : itemData.itemId === 'checkbox' ? (
              <CheckboxEditOverlayChip item={itemData} />
            ) : itemData.itemId === 'sign-date' ? (
              itemData?.signer ? (
                <SignDateWithEmailAssignEditChip item={itemData} />
              ) : (
                <SignDateEditOverlayChip item={itemData} />
              )
            ) : itemData.itemId === 'text-box' ? (
              <TextBoxEditOverlayChip item={itemData} />
            ) : itemData.itemId === 'sd-textarea' ? (
              <TextAreaEditOverlayChip item={itemData} />
            ) : itemData.itemId === 'sd-dropdown' ? (
              <DropdownEditOverlayChip item={itemData} />
            ) : itemData.itemId === 'line-item' ? (
              <LineItemEditOverlayChip item={itemData} />
            ) : item.itemId === 'sd-image' ? (
              <ImageEditOverlayChip item={itemData} />
            ) : item.itemId === 'sd-link' || item.type === 'link' ? (
              <LinkEditOverlayChip item={item} />
            ) : itemData.itemId === 'sd-file' ? (
              <FileUploadEdit item={itemData} />
            ) : itemData.itemId === 'sd-payment' ? (
              <CustomButtonWrapper
                x={item.x}
                y={item.y}
                buttonColor={item?.color}
              >
                {item?.text || 'Make Payment'}
              </CustomButtonWrapper>
            ) : item.type === 'file' ? (
              <PrefilledFieldsImageEditOverlayChip item={itemData} />
            ) : (
              <PrefilledFieldsEditOverlayChip item={itemData} />
            )}
          </div>
        </div>
      </ChipContainer>
    </>
  );
};

export default CustomDragLayerBody;
